// extracted by mini-css-extract-plugin
export default {"DigitInput":"DigitInput_DigitInput__E30Q6","DigitInput__Digit":"DigitInput_DigitInput__Digit__pk210","DigitInput__Control":"DigitInput_DigitInput__Control__vVuJv"};